import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import * as ActionsTimerManager from "../../actions/actionsTimerManager";
import * as Utils from "../../utils/utils";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

class CountdownTimer extends PureComponent {

	render() {
		const { timer, timerKey } = this.props;
		// console.log("CountdownTimer render", this.props);
		if (!timer || timer === null || !timer.hasOwnProperty("type")) {
			return null;
		}

		let time;
		if (timer.type === "alarm") {
			time =
				<span style={{ color: "white" }}>{timer.endTime.toString()}</span>;
		} else {
			time =
				<span style={{ color: "white" }}>{Utils.zeroPrefix(timer.hours) + ":" + Utils.zeroPrefix(timer.minutes) + ":" + Utils.zeroPrefix(timer.seconds)}</span>;
		}

		if (this.props.compact) {
			let modal = timer.hasOwnProperty("mode") && timer.mode === "modal";

			let restart;
			if (!timer.repeat && timer.mode !== "modal" && (timer.type === "countdown" || timer.type === "countup")) {
				restart =
					<div style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", padding: 5 }} onClick={() => {
						this.props.dispatch(ActionsTimerManager.restartCountdownTimer, timerKey);
					}}>
					<FontAwesomeIcon icon="repeat" style={{ fontSize: 26 }} color="white" />
					</div>;
			} else {
				restart =
					<div style={{ width: 26, height: 26, padding: 5 }} />;
			}

			let trash =
				<div style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", padding: 5 }} onClick={() => {
					this.props.dispatch(ActionsTimerManager.deleteTimer, timerKey);
				}}>
					<FontAwesomeIcon icon="trash" style={{ fontSize: 26 }} color="white" />
				</div>;

			let repeatIcon;
			if (timer.repeat) {
				repeatIcon =
					<FontAwesomeIcon icon="repeat" style={{ fontSize: 8 }}  color="white" />;
			}

			let timerFontSize;

			let t = timer.type === "countup" ? ActionsTimerManager.getTimeElapsed(timer.startTime) : ActionsTimerManager.getTimeRemaining(timer.endTime);

			const tablet = (window.innterWidth > 600);
			let scale = 1;
			if (!tablet) {
				scale = .75;
			}

			if (timer.type === "countup") {
				timerFontSize = 48*scale;
			} else if (t.days > 0) {
				timerFontSize = 66*scale;
			} else if (t.hours > 0) {
				timerFontSize = 86*scale;
			} else if (t.minutes > 0) {
				timerFontSize = 96*scale;
			} else {
				timerFontSize = 156*scale;
			}

			let label1FontSize, label2FontSize, paddingTop;
			if (modal) {
				paddingTop = "75px";
				label1FontSize = 48*scale;
				label2FontSize = 36*scale;
			} else {
				paddingTop = 0;
				label1FontSize = 22*scale;
				label2FontSize = 16*scale;
			}

			let label = null;
			if ((timer.label1 && timer.label1 !== "") && (timer.label2 && timer.label2 !== "")) {
				label =
					<div style={{ display: "flex", flexDirection: "column", paddingLeft: "15px", paddingRight: "15px", paddingTop: paddingTop, flex: 0, alignItems: "center", justifyContent: "center" }}>
						<div style={{ color: "white", fontSize: label1FontSize }}>{timer.label1}</div>
						<div style={{ color: "#cccccc", fontSize: label2FontSize }}>{timer.label2}</div>
					</div>;
			} else if ((timer.label1 && timer.label1 !== "")) {
				label =
					<div style={{ display: "flex", flexDirection: "column", paddingLeft: "15px", paddingRight: "15px", paddingTop: paddingTop, flex: 0, alignItems: "center", justifyContent: "center" }}>
						<div style={{ color: "white", fontSize: label1FontSize }}>{timer.label1}</div>
					</div>;
			}
			
			// if ((!timer.countdownTime || timer.countdownTime === "") || timer.days > 0) {
			// 	timerFontSize = 66;
			// } else if (timer.hours > 0) {
			// 	timerFontSize = 86;
			// } else if (timer.minutes > 0) {
			// 	timerFontSize = 96;
			// } else {
			// 	timerFontSize = 156;
			// }

			if (!timer.enabled && (timer.type === "countdown" || timer.type === "countup")) {

				return (
					<div style={{display: "flex", flex: 1, flexDirection: timer.hasOwnProperty("mode") && timer.mode === "modal" ? "column": "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
						{restart}
						<div style={{ display: "flex", flexDirection: "column", flex: 4, alignItems: "center", justifyContent: "center" }}>
							{label}	
							<div style={{ display: "flex",flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
								{modal &&
									<div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
										<span style={{ fontFamily: "Courier", fontWeight: "bold", fontSize: 66, color: "white", paddingLeft: 5, paddingRight: 10, paddingTop: 5, paddingBottom: 5 }}>{!timer.countdownTime || timer.countdownTime === "" ? "Timer Complete" : timer.countdownTime}</span><span>{repeatIcon}</span>
									</div>
								}
								{!modal &&
									<div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
										<span style={{ fontFamily: "Courier", fontWeight: "bold", fontSize: timer.countdownTime && timer.countdownTime.length < 12 ? 26 : 22, color: "white", paddingLeft: 5, paddingRight: 10, paddingTop: 5, paddingBottom: 5 }}>{!timer.countdownTime || timer.countdownTime === "" ? "Timer Complete" : timer.countdownTime}</span><span>{repeatIcon}</span>
									</div>
								}
							</div>
						</div>	
						{(!timer.hasOwnProperty("hideDismiss") || !timer.hideDismiss) && trash}
					</div>
				);
			} else {
				return (
					<div style={{ display: "flex", flex: 1, flexDirection: modal ? "column": "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
						{!modal && <div style={{ flex: 1, width: 26, height: 26, padding: 5 }} />}
						<div style={{ display: "flex", flexDirection: "column", flex: 4, alignItems: "center", justifyContent: "center" }}>
							{label}
							<div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
								{modal &&
									<div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
										<span style={{ fontFamily: "Courier", fontWeight: "bold", fontSize: timerFontSize, color: "white", paddingLeft: 5, paddingRight: 10, paddingTop: 5, paddingBottom: 5 }}>{!timer.countdownTime || timer.countdownTime === "" ? "" : timer.countdownTime}</span><span>{repeatIcon}</span>
									</div>
								}
								{!modal &&
									<div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
										<span style={{ fontFamily: "Courier", fontWeight: "bold", fontSize: timer.countdownTime && timer.countdownTime.length < 12 ? 26 : 22, color: "white", paddingLeft: 5, paddingRight: 10, paddingTop: 5, paddingBottom: 5 }}>{!timer.countdownTime || timer.countdownTime === "" ? "" : timer.countdownTime}</span><span>{repeatIcon}</span>							
									</div>
								}
							</div>
						</div>	
						{(!timer.hasOwnProperty("hideDismiss") || !timer.hideDismiss) && trash}
					</div>
				);
			}
		} else {
			let restart;
			if (!timer.repeat && !timer.enabled && (timer.type === "countdown" || timer.type === "countup")) {
				restart =
					<div style={{ color: "#008800", cursor: "pointer", fontSize: 18 }} onClick={() => { this.props.dispatch(ActionsTimerManager.restartCountdownTimer, timerKey); }}>Restart</div>;
			}

			return (
				<div style={{display: "flex", flexDirection: "column", marginTop: 15, alignItems: "center", justifyContent: "center", width: "100%"}}>					
					<div style={{ marginTop: 10, fontWeight: "bold", color: "white" }}>{"Time"}</div>
					{time}
					<div style={{ marginTop: 5, fontWeight: "bold", color: "white" }}>{"Remaining"}</div>
					<div style={{ color: "white" }}>{timer.countdownTime}</div>
					<div style={{ marginTop: 5, fontWeight: "bold", color: "lightgray" }}>{"Message"}</div>
					<div style={{ color: "lightgray" }}>{timer.action ? timer.action.message : ""}</div>
					<div style={{ height: 10 }} />
						<div onClick={() => { this.props.dispatch(ActionsTimerManager.deleteTimer, timerKey);}} style={{color: "#880000", cursor: "pointer", fontSize: 18}}>Delete</div>						
					<div style={{ height: 10 }} />
					{restart}
					<div style={{ height: 10 }} />
				</div>
			);
		}
	}
}

export default branch((props) => {
	return {
		timer: ["timers", props.timerKey]
	};
}, CountdownTimer);
